var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-component",class:`${_vm.dialogType}-dialog`},[_c('van-popup',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(_vm._f("typeToComponentName")(_vm.dialogType),{tag:"component",on:{"closeDialog":_vm.closeDialog}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }